import { create } from "zustand";
import { NotificationDetail } from "../../interfaces/Commons/Notifications/notificationDetails";
import { devtools } from "zustand/middleware";

interface NotificationDetails {
    notificationDetails: NotificationDetail[];
    setNotificationDetails: (by: NotificationDetail[]) => void;
    addNotificationDetails: (by: NotificationDetail) => void;
    deleteNotificationDetails: (by: number) => void;
    getNotificationDetailsByNotificationId: (notificationId: number) => NotificationDetail | undefined;
    mergeNotificationDetails: (notifications: NotificationDetail[]) => void
}


export const useNotificationDetailsStore = create<NotificationDetails>()(
    devtools(
    (set, get) => ({
    notificationDetails: [],
    setNotificationDetails: (by: NotificationDetail[]) => {
        set({ notificationDetails: by });
    },
    addNotificationDetails: (by: NotificationDetail) => {
        set((state) => ({ notificationDetails: [...state.notificationDetails, by] }))
    },
    deleteNotificationDetails: (notificationDetailId: number) => {
        set((state) => ({
            notificationDetails: state.notificationDetails.filter((notificationDetail) => notificationDetail.notification_details_id != notificationDetailId)
        }))
    },
    getNotificationDetailsByNotificationId: (notificationId: number) => {
        return get().notificationDetails.find((notificationDetail: NotificationDetail) => notificationDetail.notification_id === notificationId)
    },
    mergeNotificationDetails: (newNotificationDetails: NotificationDetail[]) => {
        set((state) => {
            const existingNotificationDetails = state.notificationDetails;

            const uniqueNotificationDetails = newNotificationDetails.filter(
                (newNotificationDetail) =>
                    !existingNotificationDetails.some(
                        (existing) => existing.notification_details_id === newNotificationDetail.notification_details_id
                    )
            );

            if (uniqueNotificationDetails.length === 0) {
                return {};
            }

            const updatedNotificationDetails = [...existingNotificationDetails, ...uniqueNotificationDetails];

            return {
                notificationDetails: updatedNotificationDetails
            };
        });

    }

})));